import { Api } from "../services/api";
import { IChangePasswordActionData, IExpiredPasswordActionData } from "../utils/types";
import { getDataPostChangePasswordActionToEsqueceuSenhaEndPoint, getDataPostChangePasswordActionToExpiredSenhaEndPoint } from "../ui/pages/Login/LoginUtils";
const qs = require('qs');
export async function LoginRequest(username: string, password: string, countryId: number, language: string) {
    try {
        const json = qs.stringify({
            grant_type: 'password',
            username: username,
            password: password,
            country_id: countryId,
            language_user: language
        });

        const request = await Api.post('token', json);

        return request.data;
    } catch (error) {
        return null;
    }
}
export async function Logout(token: string | null, user) {
    const axios = require('axios');
    const Value = JSON.stringify({
        "UserAutoScroll": user.UserAutoScroll,
        "Data": user.Data,
        "HorarioIni": user.HorarioIni,
        "Horario": user.Horario,
        "Language": {
            "Id": user.Language.Id
        },
        "Periodicidade": {
            "Id": user.Periodicidade.Id
        },
        "Praca": {
            "Id": user.Praca.Id,
            "Desc": user.Praca.Desc,
            "Abrev": user.Praca.Abrev
        },
        "Target": {
            "Id": user.Target.Id
        },
        "Indice": user.Indice,
        "Ordenacao": user.Ordenacao,
        "Country": {
            "CountryID": user.Country.CountryID
        },
        "PracaImagem": user.PracaImagem,
        "ChangeAutoUpdate": user.ChangeAutoUpdate,
        "TipoBase": user.TipoBase,

    });
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_HOST + 'api/session',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data:
        {
            Value
        },
    };

    const request = await axios.request(options);
    return request;
}
export async function ForgotPassword(email: string, countryId: number, language: string) {
    const params = {
        countryID: countryId,
        email: email,
        language: language
    }
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/esqueceusenha',
        params: params,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const request = await axios.request(options);
    return request;
}

export async function ChangePasswordAction(changePasswordActionData: IChangePasswordActionData, user) {

    const axios = require('axios');

    const Value = JSON.stringify({
        "UserAutoScroll": user.UserAutoScroll,
        "Data": user.Data,
        "HorarioIni": user.HorarioIni,
        "Horario": user.Horario,
        "Language": {
            "Id": user.Language.Id
        },
        "Periodicidade": {
            "Id": user.Periodicidade.Id
        },
        "Praca": {
            "Id": user.Praca.Id,
            "Desc": user.Praca.Desc,
            "Abrev": user.Praca.Abrev
        },
        "Target": {
            "Id": user.Target.Id
        },
        "Indice": user.Indice,
        "Ordenacao": user.Ordenacao,
        "Country": {
            "CountryID": user.Country.CountryID
        },
        "PracaImagem": user.PracaImagem,
        "ChangeAutoUpdate": user.ChangeAutoUpdate,
        "TipoBase": user.TipoBase,
        "Password": changePasswordActionData.oldPassword,
        "NewPassword": changePasswordActionData.newPassword,
        "ConfirmationPassword": changePasswordActionData.newConfirmPassword

    });
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_HOST + 'api/pass',
        headers: {
            Authorization: "Bearer " + changePasswordActionData.token,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data:
        {
            Value
        },
    };
    const request = await axios.request(options);
    return request;
}
export async function ForgotPasswordAction(changePasswordActionData: IChangePasswordActionData) {
    const dataRequestForm = getDataPostChangePasswordActionToEsqueceuSenhaEndPoint(changePasswordActionData);
    try {
        const json = qs.stringify(dataRequestForm);
        const request = await Api.post('api/esqueceusenha', json);
        return request;
    } catch (error) {
        return null;    
    }
}


export async function ExpiredPasswordAction(expiredPasswordActionData: IExpiredPasswordActionData) {
    const axios = require('axios');
    const qs = require('qs');
    const data = {
        userName: expiredPasswordActionData.UserName,
        countryId: expiredPasswordActionData.CountryId,
        password: expiredPasswordActionData.Password,
        newPassword: expiredPasswordActionData.NewPassword,
        confirmationPassword: expiredPasswordActionData.ConfirmationPassword,
    };
    const payload = qs.stringify(data);
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_HOST + 'api/PassExpired',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: payload
    };
    const request = await axios.request(options);
    return request;
}
